import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { NavLink, useNavigate} from "react-router-dom";
import Logo from "../assets/webLogo.png";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { loginRoute } from "../utils/APIroutes";

const Login = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    username: "",
    password: "",
  });

  const toastOptions = {
    position: "bottom-right",
    autoClose: 8000,
    draggable: true,
    theme: "dark",
  };

  useEffect(()=>{
    if(localStorage.getItem("chat-app-user")){
      navigate('/')
    }
  },[navigate])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      const { password, username } = values;
      const { data } = await axios.post(loginRoute, {
        username,
        password,
      });
      if (data.status === false) {
        toast.error(data.msg, toastOptions);
      }
      if (data.status === true) {
        localStorage.setItem("chat-app-user", JSON.stringify(data.userCheck));
        navigate('/')
      }
    }
  };

  const handleValidation = () => {
    const { password, username } = values;

     if (username === "") {
      toast.error("Usename is required", toastOptions);
      return false;
    } else if (password === "") {
      toast.error("Password is required", toastOptions);
      return false;
    }
    else{
      return true;
    }
  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <>
      <FormConatiner>
        <form method="POST">
          <div className="brand">
            <img src={Logo} alt="logo" />
            <h1>Chatify</h1>
          </div>
          <input
            type="text"
            placeholder="Username"
            name="username"
            onChange={handleChange}
            min="3"
          />
          <input
            type="password"
            placeholder="password"
            name="password"
            onChange={handleChange}
          />
          <button type="submit" onClick={handleSubmit}>
            Login
          </button>
          <span>
            Don't have an account?
            <NavLink to="/register">Register</NavLink>
          </span>
        </form>
      </FormConatiner>
      <ToastContainer />
    </>
  );
};
const FormConatiner = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  .brand {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
    img {
      height: 5rem;
    }
    h1 {
      color: #fff;
      text-transform: uppercase;
    }
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    background-color: #00000076;
    border-radius: 2rem;
    padding: 3rem 5rem;
    input {
      background-color: transparent;
      padding: 1rem;
      border: 0.1rem solid #4e0eff;
      border-radius: 0%.4rem;
      color: #fff;
      width: 100%;
      font-size: 1rem;
      &:focus {
        border: 0.1rem solid #997af0;
        outline: none;
      }
    }
    button {
      background-color: #e71ca8;
      color: #fff;
      padding: 1rem 2rem;
      border: none;
      font-weight: bold;
      cursor: pointer;
      border-radius: 0.4rem;
      font-size: 1rem;
      text-transform: uppercase;
      transition: 0.5s;
      &:hover {
        background-color: #4e0eff;
      }
    }
    span {
      color: #fff;
      text-transform: uppercase;
      a {
        color: #4e0eff;
        margin-left: 2px;
        text-decoration: none;
        font-weight: bold;
      }
    }
  }

  @media screen and (max-width: 700px) {
    .brand {
      gap: 1rem;
      img {
        height: 3.3rem;
      }
      h1 {
        font-size:1.6rem;
      }
    }
    form {
      align-items: center;
      gap: 1.2rem;
      border-radius: 1rem;
      padding: 1.3rem 2rem;
      input {
        width: 90%;
        padding: .7rem;
        border: 0.1rem solid #4e0eff;
        font-size: .8rem;
      }
      button {
        padding: .6rem 2rem;
        font-size: 1rem;
      }
    }
    }
  @media screen and (max-width: 400px) {
    .brand {
      gap: .6rem;
      img {
        height: 3rem;
      }
      h1 {
        font-size:1rem;
      }
    }
    form {
      height:400px;
      width:auto;
      justify-content:center
      gap: 2rem;
      border-radius: 1rem;
      padding: 2rem 0rem;
      input {
        width: 80%;
        padding: .8rem .4rem;
        font-size: .8rem;
        margin-top: .4rem;
      }
      button {
        margin-top: .4rem;
        padding: .3rem 1rem;
        font-size: 1rem;
      }
      span {
        width: 60%;
        text-align: center;
      }
    }
    }
  @media screen and (max-width: 300px) {
    form {
      width:240px;
      input {
        width: 65%;
        padding: .8rem .4rem;
        font-size: .8rem;
        margin-top: .4rem;
      }
      button {
        margin-top: .4rem;
        padding: .3rem 1rem;
        font-size: 1rem;
      }
      span {
        width: 50%;
        text-align: center;
      }
    }
    }
`;

export default Login;
